import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import { PayoutBillingResponseItem, PayoutBillingTableData, PayoutBillingTableRowActions } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: PayoutBillingResponseItem[],
  actions: PayoutBillingTableRowActions
): PayoutBillingTableData[] =>
  data.map((payoutBillingItem: PayoutBillingResponseItem) => {
    const { cost, amount, id, ...rest } = payoutBillingItem;

    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      amount: amount.value,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
